import { mapGetters, mapActions } from 'vuex';
import { CATEGORY, UPSELL, MENU_ITEMS } from '@/stores/defs';
import upsellService from '@/services/upsell.service';
import ContentModal from '@ContentModal';
import CartItemUpsell from '@Menu/CartItemUpsell.vue';

import {
	cloneDeep,
	flatMapDeep,
	reduce,
	filter,
	shuffle,
	forEach,
	isEmpty,
} from 'lodash';

const upsellMixin = {
	data() {
		return {
			upsells: [],
		};
	},
	computed: {
		...mapGetters({
			getUpsellItems: UPSELL.GET_ITEMS,
			getCategories: CATEGORY.GET_AVAILABLE,
			showUpsell: UPSELL.SHOW_UPSELL,
			getItem: MENU_ITEMS.GET_ITEM,
		}),
	},
	methods: {
		...mapActions({
			setUpsellItems: UPSELL.SET_ITEMS,
			setShowUpsellOn: UPSELL.ON,
			setShowUpsellOff: UPSELL.OFF,
		}),
		// TODO temporary method which creates items for upsell, replace with configurable call
		setupUpsellItems() {
			const categories = cloneDeep(this.getCategories);
			const values = flatMapDeep(categories, (category) => {
				return category.subCategories[0].sections[0].items.length;
			});
			// TODO remove '_' on lodash functions throughout program, replace
			// ecma script implementation with lodash version
			// (better handling on undefined behavior)
			const sum = reduce(values, (accumulator, value) => {
				return (accumulator + value);
			}, 0);
			const average = Math.ceil(sum / values.length);
			// assumes last category is specials
			categories.pop();
			let items = flatMapDeep(categories, (category) => {
				const items = category.subCategories[0].sections[0].items;
				if (items.length > average) {
					return null;
				}
				return items;
			});
			items = filter(items, (item) => {
				if (!item) {
					return false;
				}
				const menuItem = this.getItem(item);
				if (menuItem.outOfStock) {
					return false;
				}
				return true;
			});
			this.setUpsellItems(shuffle(items));
		},
		checkForItemUpsell(itemIds) {
			upsellService.getUpsells().then((upsells) => {
				const matches = filter(upsells, (upsell) => {
					return upsell.itemRule(itemIds);
				});
				this.upsells = matches;
			});
		},
		optionsHaveExcludedChoice(options) {
			let excludedChoices = false;
			forEach(options, (option) => {
				forEach(option.choices, (choice) => {
					if (choice['hasExcludedChoices']) {
						excludedChoices = true;
					}
				});
			});
			return excludedChoices;
		},
		recommendUpgrade(item, cartOptions) {
			const excludedChoices = this.optionsHaveExcludedChoice(cartOptions);
			if (isEmpty(this.upsells) || excludedChoices) {
				return Promise.resolve();
			}
			let useUpsell = this.upsells.shift();
			while (useUpsell && !useUpsell.ruleApplicable(cartOptions)) {
				useUpsell = this.upsells.shift();
			}
			if (!useUpsell) {
				return Promise.resolve();
			}
			const isTablet = (+this.$el.clientWidth >= 768);
			const isPhone = (this.$isMobile && !isTablet);
			const modalWidth = (isPhone) ? '100%' : '420px';
			const modalHeight = (isPhone) ? '100%' : '400px';
			const promise = new Promise((resolve, reject) => {
				this.$modal.show(ContentModal, {
					contentComponent: CartItemUpsell,
					header: {
						title: 'Upgrade',
						showBackButton: false,
						popup: true,
					},
					footer: {
						showFooter: false,
					},
					contentProperties: {
						upsell: useUpsell,
						item,
					},
				}, {
					name: 'contentModal',
					width: modalWidth,
					height: modalHeight,
					scrollable: false,
					clickToClose: false,
					overlayTransition: 'overlay-fade',
					delay: 1000,
				}, {
					closed: (event) => {
						resolve();
					},
				});
			});
			return promise;
		},
	},
};

export default upsellMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/upsellMixin.js